<div class="opptakslinje">
  <mat-icon class="mikrofon" aria-hidden="true" [style.font-weight]="mikrofonvekt()">mic</mat-icon>
  @if (viserPuls()) {
    <div class="puls-wrapper">
      <div class="puls-dot" [style.opacity]="lydnivaa()"></div>
    </div>
  }
  <span class="varighet" role="timer" [matTooltip]="'Opptakets varighet'|translate">{{ varighet() }}</span>
  <span class="tittel" (click)="gaaTilMoete()" [matTooltip]="'Navigerer til møtet transkripsjonen er knyttet til'|translate">
    {{ 'Transkripsjon av {tittel} {nummer}'|translate: {tittel: moete().tittel, nummer: moete().nummer} }}
  </span>
  <div class="handlinger">
    @switch (tilstand()) {
      @case ('started') {
        <button mat-stroked-button color="primary" type="button" (click)="pause()" [matTooltip]="'Sett opptak på pause'|translate" data-testid="pause-knapp">
          <mat-icon>pause</mat-icon>
          {{'Pause'|translate}}
        </button>
      }
      @case('paused'){
        <button mat-stroked-button color="primary" type="button" (click)="fortsett()" [matTooltip]="'Fortsetter opptaket'|translate" data-testid="fortsett-knapp">
          <mat-icon>play_circle</mat-icon>
          {{'Start'|translate}}
        </button>
      }
    }

    @if (stopper()) {
      <div class="stopper">
        <mat-progress-spinner mode="indeterminate" diameter="18" color="warn"/>
        <span class="stoppetekst">{{ 'Stopper …'|translate }}</span>
      </div>
    } @else {
      <button mat-stroked-button color="warn" type="button" (click)="stopp()" [disabled]="stoppKnappDeaktivert()" [matTooltip]="'Stopp opptak'|translate" data-testid="stopp-knapp">
        <mat-icon>stop</mat-icon>
        {{'Stopp'|translate}}
      </button>
    }
    <!-- på sikt bør dette innslaget fjernes -->
    @if (brukerHarKiFeature()){
      <button mat-icon-button color="primary" type="button" [attr.aria-label]="'Vis transkripsjon'|translate"
              (click)="visTranskripsjoner()" [disabled]="lasterTranskripsjoner()">
        <mat-icon>subject</mat-icon>
      </button>
    }
  </div>

  @if (sisteFeil() != null) {
    <div class="feil">
      <mat-icon color="warn" aria-hidden="true">error</mat-icon>
      <span>{{ sisteFeil() }}</span>
    </div>
  }

  <!--opptaket fortsetter, men uten lyd blir det ingenting å transkribere – derfor tilbud om å bytte mikrofon-->
  @if (mikrofonstatus() === 'frakoblet') {
    <div class="mikrofonvarsel" role="alert" data-testid="mikrofon-frakoblet">
      <mat-icon color="warn" aria-hidden="true">mic_off</mat-icon>
      <span>{{ 'Mikrofonen er koblet fra, og lyden tas ikke lenger opp'|translate }}</span>
      <ng-container *ngTemplateOutlet="byttMikrofonKnapp; context: {aarsak: 'mikrofonFrakoblet'}"/>
    </div>
  } @else if (mikrofonstatus() === 'dempet') {
    <div class="mikrofonvarsel" role="alert" data-testid="mikrofon-dempet">
      <mat-icon color="warn" aria-hidden="true">mic_off</mat-icon>
      <span>{{ 'Mikrofonen er dempet, og fanger ikke opp lyd'|translate }}</span>
      <ng-container *ngTemplateOutlet="byttMikrofonKnapp; context: {aarsak: 'mikrofonDempet'}"/>
    </div>
  } @else if (ingenLyd()) {
    <div class="mikrofonvarsel" role="alert" data-testid="ingen-lyd">
      <mat-icon color="warn" aria-hidden="true">mic_off</mat-icon>
      <span>{{ 'Mikrofonen har ikke fanget opp lyd det siste halve minuttet'|translate }}</span>
      <ng-container *ngTemplateOutlet="byttMikrofonKnapp; context: {aarsak: 'ingenLyd'}"/>
    </div>
  }

  <!--lydfilene venter på klienten og forsøkes lastet opp på nytt, så opptaket fortsetter – derfor kun status-->
  @if (opplastingFeiler()) {
    <div class="opplastingsfeil" role="status" data-testid="opplasting-feiler">
      <mat-icon color="warn" aria-hidden="true">cloud_off</mat-icon>
      <span>{{ 'Får ikke lastet opp lydopptaket. Opptaket fortsetter, og {antall} lydfiler lastes opp så snart forbindelsen er tilbake.'|translate: {antall: ventendeLydfiler()} }}</span>
    </div>
  }

  <!--opptaket er stoppet, linja vises kun for å forklare hvorfor, se MøteLydopptakInnspillingAktivertKomponent-->
  @if (avbrudd(); as avbrudd) {
    <div class="avbrudd" role="alert" data-testid="avbrudd">
      <mat-icon color="warn" aria-hidden="true">error</mat-icon>
      <span>
        @if (avbrudd.type === 'opplasting') {
          {{ 'Opptaket stoppet fordi lydfilene ikke kunne lastes opp ({feil}).'|translate: {feil: avbrudd.message} }}
        } @else if (avbrudd.type === 'maks_opptakslengde_overskredet') {
          {{ 'Den maksimal lengden på {maksLengde} lydopptak for et møte er overskredet. Du kan ikke ta opp ytterligere lyd på dette møtet'|translate: {maksLengde: avbrudd.data | duration} }}
        } @else {
          {{ 'Opptaket stoppet fordi mikrofonen sluttet å virke.'|translate }}
        }
      </span>
      <button mat-stroked-button color="primary" type="button" data-testid="start-paa-nytt" (click)="startPaaNytt('avbrutt')">
        {{ 'Start nytt opptak'|translate }}
      </button>
      <button mat-icon-button type="button" data-testid="lukk-avbrudd" [attr.aria-label]="'Lukk'|translate" (click)="lukkAvbrudd()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  }

  <ng-template #byttMikrofonKnapp let-aarsak="aarsak">
    <button mat-stroked-button color="warn" type="button" data-testid="bytt-mikrofon"
            (click)="startPaaNytt(aarsak)" [disabled]="stopper()"
            [matTooltip]="'Stopper opptaket og lar deg starte det på nytt med en annen mikrofon. Det som er tatt opp så langt beholdes.'|translate">
      {{ 'Bytt mikrofon'|translate }}
    </button>
  </ng-template>

  <!--låsen holdes ikke lenger av dette opptaket, men lyden tas fortsatt opp – derfor en advarsel og ikke en feil-->
  @if (skjemalaasfeil(); as laasfeil) {
    <div class="skjemalaasfeil" role="status" data-testid="skjemalaasfeil"
         [matTooltip]="'Låsen på møtet ble overtatt {tidspunkt}, og holdes ikke lenger av dette opptaket. Lyden tas fortsatt opp, men transkripsjonen kan bli dårligere når det samme møtet tas opp flere ganger.'|translate: {tidspunkt: laasfeil.konflikt.oppdatertDato|zoneddatetime}">
      <mat-icon color="warn" aria-hidden="true">lock_open</mat-icon>
      @if (laastAvAnnenBruker()) {
        <span>{{ 'Opptaket av møtet er overtatt av {navn}'|translate: {navn: laasfeil.konflikt.eier.navn} }}</span>
      } @else {
        <span>{{ 'Opptaket av møtet er overtatt i et annet vindu'|translate }}</span>
      }
    </div>
  }
</div>

<!-- @todo fjernes før prodsetting-->
@if (transkripsjoner(); as opptakene) {
  <div class="transkripsjoner" data-testid="transkripsjoner">
    @for (opptak of opptakene; track opptak.id) {
      <section class="opptak">
        <h4 class="opptaksoverskrift">
          <span class="tidspunkt">{{ opptak.tidspunkt|zoneddatetimeSomPlainTime|plaintime }}</span>
        </h4>
        @if (opptak.transkripsjon) {
          <p class="tekst">{{ opptak.transkripsjon }}</p>
        } @else {
          <p class="ikke-transkribert">{{ 'Opptaket er ikke transkribert ennå'|translate }}</p>
        }
      </section>
    } @empty {
      <p class="ingen-opptak">{{ 'Det er ikke gjort lydopptak av dette møtet'|translate }}</p>
    }
  </div>
}
